import {Base64} from 'js-base64';

// eslint-disable-next-line camelcase
// import {open_decrypter_session} from '../lib/zoombase-ts-bundle';
import stats from './stats';

export const initDecrypter = async (
    manifest,
    recipient,
    password,
    recipientBoxHash,
) => {
  try {
    if (!recipient) {
      throw new Error('Could not find email recipient from headers');
    }
    const recipientEmail = Base64.decode(recipient);

    if (!password) {
      throw new Error('Could not get password from url');
    }
    if (!recipientBoxHash) {
      throw new Error('Could not get recipient box hash from url');
    }
    const manifestXport = Base64.toUint8Array(manifest);

    const decrypterSession = await window.zoombase.open_decrypter_session(
        recipientEmail,
        password,
        recipientBoxHash,
        manifestXport,
    );
    return decrypterSession;
  } catch (error) {
    throw new Error('decrypt failure');
  }
};

export const initDecrypterWithMetric = stats.withMetric(
    {
      metric: stats.METRIC.DECRYPT,
      description: 'initSession',
    },
    initDecrypter);

export const decryptPieceWithMetric = (decrypterSession, index, piece) =>
  stats.withMetric({
    metric: stats.METRIC.DECRYPT,
    // originalMime is always first piece index of manifest
    description: (index === 0) ? 'decryptMsg' : 'decryptAtt',
  },
  async (index, piece) => {
    try {
      return await decrypterSession.decrypt_piece_by_index(index, piece);
    } catch (error) {
      throw new Error('decrypt failure');
    }
  }).bind(decrypterSession)(index, piece);
